import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from 'material-ui/CircularProgress';

import CargoRequestsList from './List';

import { getCargoTypes } from 'actions/cargoes/types';
import styles from 'styles/index';

class CargoRequestsPage extends React.Component {
    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.getCargoTypes();
    }

    render() {
        const { isLoaded } = this.props;

        return (
            <div id='cargo-requests' className='requests-page page'>
                <CircularProgress
                    className={!isLoaded ? '' : 'hidden'}
                    style={styles.circularProgress}
                />

                <div className={this.props.isLoaded ? '' : 'hidden'}>
                    <div className='container'>
                        <h2>
                            Сargo requests
                        </h2>
                        <CargoRequestsList />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ cargoRequests: { isLoaded } }) => ({
        isLoaded,
    }),
    dispatch => bindActionCreators(
        {
            getCargoTypes,
        },
        dispatch,
    ),
)(CargoRequestsPage);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Requests/Page.jsx